import {
  CellDrillDownInfoType,
  CellDrillDownInfoTypes,
  MeasureDrillDownInfo,
  MetricDrillDownInfo,
} from "../../../../api/biApi.types";

export const isMeasureDrillDownInfo = (info: CellDrillDownInfoTypes): info is MeasureDrillDownInfo => {
  return (
    info.drillDownInfoType === CellDrillDownInfoType.Default || info.drillDownInfoType === CellDrillDownInfoType.Irr
  );
};

export const isIrrDrillDownInfo = (info: CellDrillDownInfoTypes): info is MeasureDrillDownInfo => {
  return info.drillDownInfoType === CellDrillDownInfoType.Irr;
};

export const isMetricDrillDownInfo = (info: CellDrillDownInfoTypes): info is MetricDrillDownInfo => {
  return info.drillDownInfoType === CellDrillDownInfoType.Metric;
};
